import { Chip, ChipProps, MenuItem, MenuItemProps } from '@mui/material';
import { styled } from '@mui/material/styles';

export const SelectedChip = styled(Chip)<ChipProps>(({ theme }) => ({
  height: '1.75rem',
  borderRadius: '0.375rem',
  backgroundColor: theme.palette.monochrome.monoChrome2,
  border: `1px solid ${theme.palette.monochrome.monoChrome3}`,
  color: theme.palette.monochrome.monoChrome6,
  fontSize: '0.875rem',
  fontWeight: 400,
  flexShrink: 0,
}));

const MultipleDropdownMenuItemWrapper = styled(MenuItem)<MenuItemProps & { selected?: boolean }>(
  ({ theme, selected }) => ({
    fontSize: '1.125rem',
    padding: '1rem',
    fontStyle: 'normal',
    color: theme.palette.monochrome.monoChrome6,
    fontWeight: selected ? 700 : 400,
    minHeight: '3.125rem !important',
    lineHeight: '1.125rem',
    backgroundColor: `${theme.palette.background.default} !important`,
    borderTop: `1px solid ${theme.palette.monochrome.monoChrome3}`,
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    '&:first-of-type': {
      borderTop: 'none',
    },
    '&:hover': {
      backgroundColor: `${theme.palette.monochrome.monoChrome5} !important`,
    },
    '&.Mui-selected:hover': {
      backgroundColor: theme.palette.monochrome.monoChrome3,
    },
    '&.Mui-disabled.Mui-selected': {
      backgroundColor: `${theme.palette.background.default}!important`,
    },
    '&.Mui-disabled': {
      backgroundColor: theme.palette.background.default,
    },
  }),
);

export default MultipleDropdownMenuItemWrapper;
